export const DEFAULT_MENU_UPSELL_HEADER = 'People Also Ordered';

export const AB_TEST_MENU_UPSELL_HEADER = 'Complete your order with these';
